import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { TableRowNodeView } from './nodeviews/tableRow';
import { pluginKey } from './plugin-key';
import { createPluginState } from './plugin-state';
export var createPlugin = function createPlugin(dispatch, eventDispatcher) {
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return [];
  };
  var getEditorFeatureFlags = arguments.length > 3 ? arguments[3] : undefined;
  return new SafePlugin({
    state: createPluginState(dispatch, initialState),
    key: pluginKey,
    props: {
      nodeViews: {
        tableRow: function tableRow(node, view, getPos) {
          return new TableRowNodeView(node, view, getPos, eventDispatcher);
        }
      }
    }
  });
};